import { baseTheme } from '@src/theme';
import { StylesConfig } from 'react-select';
import { styled } from 'styled-components';

export const StyledAsyncSelectContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const StyledErrorMessage = styled.span`
    display: block;
    font-size: 12px;
    color: ${(props) =>
        props.theme?.colors?.error?.main?.text ||
        baseTheme.colors.error.main.text};
`;

export const getSelectStyles = (theme: any): StylesConfig<any, true> => {
    const themeToUse = theme?.colors ? theme : baseTheme;
    return {
        control: (styles, { selectProps }) => ({
            ...styles,
            backgroundColor: 'transparent',
            padding: '5px 10px',
            fontSize: '14px',
            minHeight: '32px',
            borderColor: selectProps['aria-invalid']
                ? themeToUse.colors.error.main.border
                : themeToUse.colors.secondary.light.border,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderRadius: '8px',
            boxShadow: 'none',
            '&:hover': {
                borderColor: selectProps['aria-invalid']
                    ? themeToUse.colors.error.main.border
                    : themeToUse.colors.primary.main.border,
            },
            '&:focus-within': {
                borderColor: selectProps['aria-invalid']
                    ? themeToUse.colors.error.main.border
                    : themeToUse.colors.primary.main.border,
                boxShadow: 'none',
            },
        }),
        valueContainer: (styles) => ({
            ...styles,
            // padding: '0 6px',
            marginTop: '4px',
        }),
        input: (styles) => ({
            ...styles,
            margin: '0',
            padding: '0',
            color: themeToUse.colors.secondary.main.text,
        }),
        singleValue: (styles) => ({
            ...styles,
            color: themeToUse.colors.secondary.main.text,
            margin: '0',
        }),
        placeholder: (styles) => ({
            ...styles,
            color: themeToUse.colors.neutral.dark.surfaceHover,
            margin: '0',
            fontWeight: 'lighter',
            fontSize: '12px',
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
        menu: (styles) => {
            return {
                ...styles,
                backgroundColor: themeToUse.colors.secondary.light.contentBg,
                top: '4px',
                boxShadow:
                    '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
                borderRadius: '8px',
                padding: '4px',
            };
        },
        container(base) {
            return {
                ...base,
                transition: 'all 0.3s ease',
                svg: {
                    fill: themeToUse.colors.secondary.main.icon,
                    width: '1rem',
                    cursor: 'pointer',
                    ':hover': {
                        fill: themeToUse.colors.secondary.dark.icon,
                    },
                },
            };
        },
        option: (styles, { isDisabled, isSelected }) => {
            return {
                ...styles,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                color: themeToUse.colors.secondary.main.text,
                padding: '10px 12px',
                borderRadius: '8px',
                fontSize: '14px',
                backgroundColor: isSelected
                    ? themeToUse.colors.primary.light.surfaceBg
                    : 'transparent',
                ':hover': {
                    ...styles[':hover'],
                    backgroundColor:
                        themeToUse.colors.secondary.light.surfaceHover,
                },
                ':active': {
                    ...styles[':active'],
                    backgroundColor: !isDisabled
                        ? themeToUse.colors.primary.light.surfaceBg
                        : undefined,
                },
            };
        },
        multiValue: (styles) => {
            return {
                ...styles,
                backgroundColor: 'transparent',
            };
        },
        multiValueLabel: (styles) => ({
            ...styles,
            color: themeToUse.colors.secondary.main.text,
            marginRight: '8px',
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: themeToUse.colors.secondary.main.icon,
            marginRight: '10px',
            ':hover': {
                color: `${themeToUse.colors.secondary.dark.icon}!important`,
            },
        }),
    };
};
